export enum ROUTES {
  HOME = "/",
  STANDS = "/stands",
  STAND_DETAIL = "/stands/stand-detail/:id",
  EVENTS = "/events",
  EVENT_DETAIL = "/events/event-detail/:id",
  CATEGORIES = "/categories",
  CATEGORY_DETAIL = "/categories/category/:id",
  ZOOM_PLAYER = "/join-room",
  CHAT = "/chat",
  PROFILE = "/profile",
  SEARCH = "/search",
  SIGN_IN = "/sign-in",
  SIGN_UP = "/sign-up",
  FORGOT_PASSWORD = "/forgot-password",
  PRE_REGISTERED = "/pre-registered",
  LINKEDIN_SIGN_IN = "/linkedin-sign-in",
  CONFIRM_EMAIL = "/confirm-email",
  AUTH_ACTION = "/auth-action",
  COMPLETE_PROFILE = "/complete-profile",
  FAQ = "/faq",
  TUTORIALS = "/tutorials",
  TERMS_OF_SERVICE = "/terms-of-service",
  PRIVACY_POLICY = "/privacy-policy",
  COOKIE_POLICY = "/cookie-policy",
  COMING_SOON = "/coming-soon",
}

export enum ROUTES_KEYS {
  HOME = "home",
  STANDS = "stands",
  STAND_DETAIL = "stand-detail",
  EVENTS = "events",
  EVENT_DETAIL = "event-detail",
  CATEGORIES = "categories",
  CATEGORY_DETAIL = "category-detail",
  ZOOM_PLAYER = "zoom-player",
  CHAT = "chat",
  PROFILE = "profile",
  SEARCH = "search",
  SIGN_IN = "sign-in",
  SIGN_UP = "sign-up",
  FORGOT_PASSWORD = "forgot-password",
  PRE_REGISTERED = "pre-registered",
  LINKEDIN_SIGN_IN = "linkedin-sign-in",
  CONFIRM_EMAIL = "confirm-email",
  AUTH_ACTION = "auth-action",
  COMPLETE_PROFILE = "complete-profile",
  TUTORIALS = "tutorials",
  FAQ = "faq",
  TERMS_OF_SERVICE = "terms-of-service",
  PRIVACY_POLICY = "privacy-policy",
  COOKIE_POLICY = "cookie-policy",
  COMING_SOON = "coming-soon",
}
